module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_6-eed382db8d7c515ffa171d9ddc7249c9.jpg";